import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-195125c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-realizedBudget" }
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "Realizado x Orçamento", -1))
const _hoisted_4 = { class: "card-title" }
const _hoisted_5 = {
  key: 2,
  class: "flexLegend",
  style: {"padding-bottom":"10px"}
}
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-baseline\" data-v-195125c6><div class=\"box-legend budgeted\" data-v-195125c6></div><p class=\"legend-text\" data-v-195125c6>Orçado</p></div><div class=\"d-flex align-items-baseline\" data-v-195125c6><div class=\"box-legend accomplished\" data-v-195125c6></div><p class=\"legend-text\" data-v-195125c6>Realizado</p></div><div class=\"d-flex align-items-baseline\" data-v-195125c6><div class=\"box-legend positiveBalance\" data-v-195125c6></div><p class=\"legend-text\" data-v-195125c6>Saldo Positivo</p></div><div class=\"d-flex align-items-baseline\" data-v-195125c6><div class=\"box-legend negativeBalance\" data-v-195125c6></div><p class=\"legend-text\" data-v-195125c6>Saldo negativo</p></div>", 4)
const _hoisted_10 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Overlay = _resolveComponent("Overlay")!
  const _component_NoAccess = _resolveComponent("NoAccess")!
  const _component_VChart = _resolveComponent("VChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Overlay, { key: 0 }))
      : _createCommentVNode("", true),
    (!_ctx.access && !_ctx.loading)
      ? (_openBlock(), _createBlock(_component_NoAccess, { key: 1 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.channelName), 1)
    ]),
    (_ctx.access && !_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_10))
      : _createCommentVNode("", true),
    (_ctx.access)
      ? (_openBlock(), _createBlock(_component_VChart, {
          key: 3,
          ref: "chart",
          class: _normalizeClass(["chart", {
        loadingClass: _ctx.loading,
      }]),
          option: _ctx.options,
          autoresize: ""
        }, null, 8, ["option", "class"]))
      : _createCommentVNode("", true)
  ]))
}